import { useEffect, useState } from 'react'

import { formatDate } from './formatDate'

export const useRelativeDate = (date: string | null | undefined) => {
  const [text, setText] = useState('')
  useEffect(() => {
    if (!date) return

    const target = new Date(date + (date.length === 10 ? 'T18:00:00' : ''))
    const diff = differenceInCalendarDays(target, new Date())
    setText(
      (diff === 2
        ? 'overmorgen, '
        : diff === 1
          ? 'morgen, '
          : diff === 0
            ? 'vandaag, '
            : diff === -1
              ? 'gisteren, '
              : diff === -2
                ? 'eergisteren, '
                : '') +
        formatDate.format(target) +
        // Year if not current year
        (target.getFullYear() !== new Date().getFullYear()
          ? ` ${target.getFullYear()}`
          : '')
    )
  }, [date])
  return text
}

function differenceInCalendarDays(dateLeft: Date, dateRight: Date) {
  const MILLISECONDS_IN_DAY = 86400000
  const startOfDayLeft = new Date(
    dateLeft.getFullYear(),
    dateLeft.getMonth(),
    dateLeft.getDate()
  )
  const startOfDayRight = new Date(
    dateRight.getFullYear(),
    dateRight.getMonth(),
    dateRight.getDate()
  )
  const timestampLeft =
    startOfDayLeft.getTime() - startOfDayLeft.getTimezoneOffset() * 60 * 1000
  const timestampRight =
    startOfDayRight.getTime() - startOfDayRight.getTimezoneOffset() * 60 * 1000
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}
